import BaseModel from './base';
import { localeFormatDefault } from '@/plugins/date-print';
import EventAnnouncement from './event-announcement';
import { getAnnounDate } from '@/modules/EventsPlan/functions';

export default class EventAnnouncementSorted extends BaseModel {
  static fromPlan(plan) {
    const source = plan?.response || plan || {};
    const announcement = new EventAnnouncementSorted({
      event_id: plan?.event?.id || source.event_id || source.event?.id || null,
      event_name: plan?.event?.name || source.event_name || source.event?.name || null,
      plan_id: plan?.id || source.id,
      plan_name: plan?.name || source.name,
      plan_description: plan?.description || source.description,
      plan_start_at: source.start_at || plan?.start_at,
      plan_end_at: source.end_at || plan?.end_at,
    });
    announcement.setPlan(plan);
    return announcement;
  }

  constructor(announcement, url) {
    super(announcement, url);
    this.id = [Number(announcement.event_id), Number(announcement.plan_id)].join('-');
    this.name = announcement.plan_name || announcement.event_name;

    this.plan_id = announcement.plan_id;
    this.plan_name = announcement.plan_name;
    this.plan_description = announcement.plan_description;
    this.plan_start_at = announcement.plan_start_at ? localeFormatDefault(announcement.plan_start_at) : announcement.plan_start_at;
    this.plan_end_at = announcement.plan_end_at ? localeFormatDefault(announcement.plan_end_at) : announcement.plan_end_at;

    this.event_id = announcement.event_id;
    this.event_name = announcement.event_name;
    // es = event_stage
    this.es_start_at = announcement.es_start_at ? localeFormatDefault(announcement.es_start_at) : announcement.es_start_at;
    this.es_end_at = announcement.es_end_at ? localeFormatDefault(announcement.es_end_at) : announcement.es_end_at;

    this.plan = null;
  }

  get event() {
    return this.plan?.event || this.event_id || null;
  }

  get start_at() {
    const { plan_start_at } = this;
    const { es_start_at } = this;
    return plan_start_at || es_start_at;
  }

  get end_at() {
    const { plan_end_at } = this;
    const { es_end_at } = this;
    return plan_end_at || es_end_at;
  }

  get executionPlanTime() {
    const { plan_start_at, plan_end_at } = this;
    if (!plan_start_at || !plan_end_at) return null;
    return getAnnounDate(plan_start_at, plan_end_at);
  }

  get executionEventTime() {
    const { es_start_at, es_end_at } = this;
    if (!es_start_at || !es_end_at) return null;
    return getAnnounDate(es_start_at, es_end_at);
  }

  get executionTime() {
    const { executionPlanTime, executionEventTime } = this;
    return executionPlanTime || executionEventTime || '';
  }

  setPlan(val) {
    this.plan = !(val instanceof EventAnnouncement) ? new EventAnnouncement(val) : val;
  }
}
